<template>
  <el-row class="container">
    <!--头部-->
    <el-col :span="24" class="topbar-wrap">
      <div class="topbar-logos">
        <!-- <a @click="logoClick" style="cursor:pointer"><img src="../../assets/logo.png" alt="" /></a> -->
      </div>
      <div class="topbar-title">
        <!-- 注意：这里就是topNavState作用之处，根据当前路由所在根路由的type值判断显示不同顶部导航菜单 -->
        <!-- <el-row v-show="$store.state.topNavState==='home'"> -->
        <el-row>
          <el-col :span="24">
            <span v-show="showTopMenu">
              <el-menu active-text-color="#4894d8" :default-active="defaultActiveIndex" class="el-menu-demo"
                theme="light" mode="horizontal" @select="handleSelect" :router="false">
                <!-- <el-menu-item  v-for="(item, index) in $router.options.routes" :key="index"  v-if="item.menuName"   :index="item.path">{{item.menuName}}</el-menu-item>
                <el-menu-item index="/">Iot平台</el-menu-item>
                <el-menu-item index="/projectParentManager">项目管理</el-menu-item>
                <el-menu-item index="/ebaManager">设备远程监控平台</el-menu-item>
              </el-menu> -->
                <el-menu-item index="1">TCP</el-menu-item>
                <el-menu-item index="2">UDP</el-menu-item>
                <el-menu-item index="3">MQTT</el-menu-item>
                <el-menu-item index="4">HTTP</el-menu-item>
                <el-menu-item index="5">COAP</el-menu-item>
              </el-menu>
            </span>
          </el-col>
        </el-row>
      </div>
      <div class="topbar-account topbar-btn">
        <el-button type="text" style="margin-right: 20px;color: #fff;" @click="showNoviceGuideDrawer">新手引导</el-button>
        <el-button v-if="agentShow" type="text" style="margin-right: 20px;color: #fff;"
          @click="showServiceDrawerDrawer">运维智能体</el-button>
        <el-badge :is-dot="isDot" class="item">
          <i @click="infoFrame" class="el-icon-bell" style="font-size: 18px;vertical-align: -1px;cursor: pointer;"></i>
        </el-badge>
        <el-dropdown trigger="click">
          <span class="el-dropdown-link userinfo-inner" :title="nickname">
            <i class="iconfont icon-user"></i> {{ nickname }}
            <i class="el-icon-caret-bottom"></i></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <div @click="jumpTo('/user/userPersonal')">
                <span style="color: #555;font-size: 14px;">个人信息</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="jumpTo('/user/userPersonal',{changePwd:true})">
                <span style="color: #555;font-size: 14px;">修改密码</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logOut">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-col>
    <div class="modal-mask" v-if="maskVisible" @click="cancelVisible"></div>
    <transition name="slide-fade">
      <div class="detail-box" v-if="detailVisible">
        <div class="list-content roomDetails">
          <h3 class="clearfix">
            <i @click="cancelVisible" class="el-icon-close"
              style="cursor: pointer;padding:0;float:left;margin-top:3px;"></i>通知
            <el-button @click="reset" style="padding:0;float:right;margin-top:3px;" type="text">清除</el-button>
          </h3>
          <div class="infoList">
            <ul>
              <li v-for="(item, index) in warningMsg" :key="index">
                <h4>
                  {{ formatDate(item.createDate) }}（<span>{{
                    item.warningLevel
                    }}</span>）
                </h4>
                <div class="infoMain">
                  <span>{{ item.installSite }}，{{ item.devName }}</span><br />
                  <span>{{ item.content }}</span>
                </div>
                <el-button @click="remove(item.id)" type="text"
                  style="color:#9B9B9B;float: right;padding:0px;margin-right:10px;">忽略</el-button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slide-fade">
      <div class="detail-box" v-if="noviceGuideDrawer">
        <div class="list-content roomDetails">
          <h3 class="clearfix">
            <el-button @click="cancelVisible" style="padding:0;float:left;margin-top:3px;" type="text">隐藏弹窗</el-button>
            新手引导
            <el-button v-if="openNoviceGuide&&noviceGuideStep!=5" @click="closeNoviceGuide"
              style="padding:0;float:right;margin-top:3px;" type="text">退出引导</el-button>
          </h3>
          <div class="infoList" style="padding: 10px">
            <div v-if="!openNoviceGuide">
              <div style="margin-top: 10px">
                <el-divider content-position="left">概述说明</el-divider>
                该板块功能主要帮助新用户快速将设备接入平台。
              </div>
              <div style="padding-top: 40px">
                <el-divider content-position="left">接入准备</el-divider>
                设备接入平台前需要准备以下工作：
                <div style="padding-left: 20px;margin-bottom: 10px;">
                  ① 确定设备与平台通讯方式，TCP，UDP，MQTT，HTTP，COAP等，通过平台顶端菜单切换到指定通讯方式下进行接入。
                </div>
                <div style="padding-left: 20px;margin-bottom: 10px;">
                  ② 配置设备的上报地址，【网关协议库-创建网关协议】中可查看。
                </div>
                <div style="padding-left: 20px;margin-bottom: 10px;">
                  ③ 明确设备基础配置信息，如：心跳包，上报间隔，地址号等。
                </div>
                <div style="padding-left: 20px;margin-bottom: 10px;">
                  ④ 了解网关协议，复杂协议接入需要提前了解脚本编写，可参考
                  <a target="_blank" :href="developDocumentLink">【帮助文档】</a>。
                </div>
                <div style="padding-left: 20px;margin-bottom: 10px;">
                  ⑤ 了解设备协议，复杂协议接入需要提前了解脚本编写，可参考
                  <a target="_blank" :href="developDocumentLink">【帮助文档】</a>。
                </div>
              </div>
              <div @click="startNoviceGuide" style="text-align: center;margin-top: 40px">
                <el-button type="primary">已了解，引导接入</el-button>
              </div>
            </div>
            <div v-if="openNoviceGuide">
              <div style="height:550px">
                <el-steps direction="vertical" :active="noviceGuideStep">
                  <el-step title="步骤1：创建网关协议" icon="el-icon-tickets" description="网关协议用于描述网关通讯格式，用户根据已知通讯格式进行配置。">
                  </el-step>
                  <el-step title="步骤2：创建网关" icon="el-icon-connection"
                    description="网关用于平台与设备通信，网关编号系统唯一，建议填写网关唯一表示（如：IMEI号）。"></el-step>
                  <el-step title="步骤3：创建设备协议" icon="el-icon-s-order" description="设备协议用于描述设备具体数据格式，根据设备协议手册进行配置。">
                  </el-step>
                  <el-step title="步骤4：创建设备" icon="el-icon-set-up" description="设备用于采集数据，地址号为必填字段，若无地址号，默认为01.">
                  </el-step>
                  <el-step title="步骤5：查看数据" icon="el-icon-view" description="接入已完成，可前往查看设备数据。"></el-step>
                </el-steps>
              </div>
              <div style="margin-top: 30px">
                <div style="color:#67C23A" v-if="noviceGuideStep>0">
                  <i class="el-icon-circle-check"></i>
                  <span v-if="noviceGuideStep==1">您已经完成了网关协议创建。</span>
                  <span v-if="noviceGuideStep==2">您已经完成了网关创建,可前往<b>【连接设备-网关管理】</b>查看网关上线状态。</span>
                  <span v-if="noviceGuideStep==3">您已经完成了设备协议创建。</span>
                  <span v-if="noviceGuideStep==4">您已经完成了设备创建,可前往<b>【设备管理-设备管理】</b>查看设备上线状态。</span>
                  <span v-if="noviceGuideStep==5">您已经完成了设备接入全部流程，可前往<b>【设备管理-设备管理】</b>点击<b>【查看数据】</b>，验证数据是否有误。</span>
                </div>
                <div style="text-align: center;margin-top: 20px">
                  <el-button type="primary" @click="toGuide" v-if="openNoviceGuide&&noviceGuideStep<5">
                    {{noviceGuideStep==0?"创建网关协议":noviceGuideStep==1?"创建网关":noviceGuideStep==2?"创建设备协议":noviceGuideStep==3?"创建设备":"查看数据"}}
                  </el-button>
                  <el-button type="primary" v-if="noviceGuideStep<4" @click="nextStep">已存在，跳过</el-button>
                  <el-button v-if="openNoviceGuide&&noviceGuideStep==5" @click="closeNoviceGuide" type="primary">退出引导
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slide-fade">
      <div class="detail-box" v-if="serviceDrawer">
        <iframe :src="kefuUrl" style="width: 100%; height: 95%;" frameborder="0" allow="microphone"></iframe>
      </div>
    </transition>
  </el-row>
</template>

<script>
  import evnUrl from "../../api/env";
  import "element-ui/lib/theme-chalk/display.css";
  import {
    road
  } from "../../road.js";
  import API from "../../api/api_user";
  import api from "../../api/api";
  import dayjs from "dayjs";
  export default {
    inject: ['reload'],
    data() {
      return {
        loading: false,
        nickname: "",
        showMenuPath: [ //展示顶边协议类型的地址
          '/device/protocolLibraryManagement',
          '/device/protocolAdd',
          '/device/moduleManagement',
          '/device/moduleAdd',
          '/equipment/equipmentProtocolLibrary',
          '/equipment/equipmentManagement',
          '/equipment/equipmentAdd',
          '/equipment/equimentProtocolAdd',
          '/equipment/deviceTransfer'
        ],
        defaultActiveIndex: sessionStorage.getItem("commuType") ? sessionStorage.getItem("commuType") : '1',
        homeMenu: false,
        messageCount: 5,
        isDot: true, //有新消息的时候显示红点，true为显示，反之
        detailVisible: false, // 消息弹窗flag
        maskVisible: false, // 弹窗mask显示
        warningMsg: [],
        noviceGuideDrawer: false, //新手引导侧边框
        openNoviceGuide: false,
        noviceGuideStep: 0, //新手引导进度
        developDocumentLink: "../index.html",
        serviceDrawer: false, //智能客服弹窗
        kefuUrl: '',
        agentShow: true
      }
    },
    computed: {
      name() {
        return this.noviceGuideStep
      },
      showTopMenu() { //是否展示顶边协议类型
        var path = this.$route.path
        // var matchPath = path.match(/\/(\S*)\//)
        if (this.showMenuPath.indexOf(path) == -1 || this.$route.query.flag) {
          return false
        } else {
          return true
        }
      },
    },
    created() {
      this.agentShow = evnUrl.env !== 'gza'
      this.kefuUrl = evnUrl.maxkbURL
      road.$on("setNickName", text => {
        this.nickname = text;
      });
      road.$on("goto", url => {
        if (url === "/login") {
          this.$router.push(url);
        }
      });
      // 组件创建完后获取数据
      if (!sessionStorage.getItem("menus")) { //没有菜单重新获取菜单
        this.getMenu();
      } else {
        this.fetchNavData();
      }

      sessionStorage.setItem("loginExpired", false); //默认不过期，防止提醒过期弹窗时刷新
      window.addEventListener('changeNoviceGuideStep', () => {
        this.showNoviceGuideDrawer();
      })
      var that = this
      //监听登录用户状态是否改变
      var isChangeUsering = false //是否处于改变用户状态中
      window.addEventListener('storage', function (ev) {
        if ("uid" == ev.key && ev.newValue != sessionStorage.getItem("uid") && (!isChangeUsering)) {
          isChangeUsering = true;
          that.$message({
            message: '检测到此登录用户信息已变更，重新加载中',
            type: 'warning'
          });
          sessionStorage.removeItem("menus");
          sessionStorage.removeItem("btns");
          // 增加延迟，避免重复提醒和刷新
          setTimeout(() => {
            that.getMenu();
            isChangeUsering = false
          }, 1000)

        }
      })
    },
    methods: {
      //获取菜单
      getMenu() {
        API.info().then(res => {
          if (res.code === 1) {
            window.sessionStorage.setItem("btns", JSON.stringify(res.data.btnPermissions)); //按钮
            window.sessionStorage.setItem("menus", JSON.stringify(res.data.userVoList[0].menuList)); //菜单
            window.sessionStorage.setItem("commuType", sessionStorage.getItem("commuType") ? sessionStorage.getItem(
              "commuType") : 0);
            location.reload()
          } else {
            this.$message.error("获取菜单失败")
          }
        })
      },
      //获取帮助文档地址
      getDevelopDocumentLink() {
        if (sessionStorage.getItem("developDocumentLink")) {
          this.developDocumentLink = sessionStorage.getItem("developDocumentLink")
        } else {
          api.getDictionaryListByCode({
            typeCode: "developDocumentLink"
          }).then(res => {
            if (res.code === 1) {
              var dictionaryList = res.data.dictionaryList
              if (dictionaryList.length > 0) {
                this.developDocumentLink = dictionaryList[0].content;
                sessionStorage.setItem("developDocumentLink", this.developDocumentLink)
              }
            }
          })
        }
      },
      formatDate(createDate) {
        return dayjs(new Date(createDate)).format("YYYY-MM-DD HH:mm:ss");
      },
      jumpTo(url, query) {
        if (query) {
          this.$router.push({
            path: url,
            query: query
          });
        } else {
          this.$router.push(url); //用go刷新
        }
      },
      handleSelect(index) {
        window.sessionStorage.setItem("commuType", index);
        // if (this.$route.path == '/device/dashboard') {
        //   this.reload();
        //   return;
        // }
        // this.$router.push({
        //   path: "/device/dashboard"
        // });
        this.reload();
      },
      logoClick() {
        // this.defaultActiveIndex = '0';
        // sessionStorage.setItem("commuType", 0);
        this.$router.push({
          path: "/dashboard"
        });
      },
      fetchNavData() {
        // 初始化菜单激活项
        let cur_path = this.$route.path; //获取当前路由
        if (cur_path != '/dashboard') {
          this.defaultActiveIndex = window.sessionStorage.getItem("commuType") ? window.sessionStorage.getItem(
            "commuType") : '1';
        } else {
          this.defaultActiveIndex = '0';
        }
        let routers = this.$router.options.routes; // 获取路由对象
        let menu = JSON.parse(window.sessionStorage.getItem("menus")) //后台返回的菜单，不完整的，必须跟本地路由匹配
        //返回菜单做处理
        for (var i = 0; i < menu.length; i++) {
          let menuChildren = menu[i].children
          for (var j = 4; j < routers.length; j++) {
            //最高层的菜单
            if (menu[i].type == routers[j].type) {
              routers[j].name = menu[i].name
              routers[j].menuName = menu[i].menuName
              // menu[i].redirect=routers[j].redirect
              if (routers[j].meta) {
                routers[j].meta.menuShow = true
              }
            }
            let routersChildren = routers[j].children;
            for (var n = 0; n < menuChildren.length; n++) {
              let grandMenuChildren = []
              if (menuChildren[n].children) {
                grandMenuChildren = menuChildren[n].children
              }
              for (var m = 0; m < routersChildren.length; m++) {
                //第二层级的菜单
                if (menuChildren[n].menuCode == routersChildren[m].menuCode) {
                  routersChildren[m].name = menuChildren[n].menuName
                  // menuChildren[n].components=routersChildren[m].components
                  // menuChildren[n].meta=routersChildren[m].meta
                  if (routersChildren[m].meta) {
                    routersChildren[m].meta.menuShow = true
                  }
                }
                let grandRoutersChildren = []
                if (routersChildren[m].children) {
                  grandRoutersChildren = routersChildren[m].children
                }
                for (var t = 0; t < grandMenuChildren.length; t++) {
                  for (var r = 0; r < grandRoutersChildren.length; r++) {
                    //第三层级的菜单
                    if (grandMenuChildren[t].menuCode == grandRoutersChildren[r].menuCode) {
                      grandRoutersChildren[r].name = grandMenuChildren[t].menuName
                      // grandMenuChildren[t].component=grandRoutersChildren[r].component
                      // grandMenuChildren[t].meta=grandRoutersChildren[r].meta
                      if (grandRoutersChildren[r].meta) {
                        grandRoutersChildren[r].meta.menuShow = true
                      }
                    }
                  }
                }
              }
            }
          }
        }
        let nav_type = "",
          nav_name = "";
        for (var i = 0; i < routers.length; i++) {
          let children = routers[i].children;
          if (children) {
            for (let c = 0; c < children.length; c++) {
              if (children[c].path === cur_path) {
                nav_type = routers[i].type;
                nav_name = routers[i].name;
                break;
              }
              // 如果该菜单下还有子菜单
              if (children[c].children) {
                let grandChildren = children[c].children;
                for (let z = 0; z < grandChildren.length; z++) {
                  if (grandChildren[z].path === cur_path) {
                    nav_type = routers[i].type;
                    nav_name = routers[i].name;
                    break;
                  }
                }
              }
            }
          }
        }

        this.$store.state.topNavState = nav_type;
        this.$store.state.leftNavState = nav_name;
        // if (nav_type == "IotParent") {
        //   this.defaultActiveIndex = "/";
        // } else {
        //   this.defaultActiveIndex = "/" + nav_name + "Manager";
        // }
      },
      logOut() {
        this.$confirm("确认退出吗?", "提示", {
          confirmButtonClass: "el-button--warning"
        })
          .then(() => {
            //确认
            API.logout().then(res => {
              //退出登录成功
              this.$cookies.remove("access_token");
              sessionStorage.removeItem("menus");
              sessionStorage.removeItem("btns");
              sessionStorage.removeItem("routeList");
              sessionStorage.removeItem("commuType");
              sessionStorage.removeItem("openNoviceGuide")
              sessionStorage.removeItem('noviceGuideStep')
              this.$router.push({
                path: '/*'
              });
              // this.$message.success("成功退出登录");

            });
          })
          .catch(() => { });
      },
      //显示消息弹窗
      infoFrame() {
        this.maskVisible = true;
        this.detailVisible = true;
        this.noviceGuideDrawer = false;
        this.serviceDrawer = false;
        let msg = sessionStorage.getItem("warningMsg");
        if (!msg) return;

        this.warningMsg = JSON.parse(msg);
      },
      remove(id) {
        this.warningMsg.splice(this.warningMsg.findIndex(w => w.id == id), 1);
      },
      // 关闭消息弹窗
      cancelVisible() {
        this.maskVisible = false;
        this.detailVisible = false;
        this.noviceGuideDrawer = false;
        this.serviceDrawer = false;
      },
      //清除消息
      reset() {
        this.maskVisible = false;
        this.detailVisible = false;
        this.isDot = false;
        window.sessionStorage.removeItem("warningMsg");
        this.warningMsg = [];
      },
      //显示新手引导页面
      showNoviceGuideDrawer() {
        this.detailVisible = false;
        this.noviceGuideDrawer = true;
        this.maskVisible = true;
        this.serviceDrawer = false

        this.getDevelopDocumentLink();
        var openNoviceGuide = sessionStorage.getItem("openNoviceGuide")
        var noviceGuideStep = sessionStorage.getItem("noviceGuideStep")
        if ("true" == openNoviceGuide) {
          this.openNoviceGuide = true
        } else {
          this.openNoviceGuide = false
        }
        if (noviceGuideStep) {
          this.noviceGuideStep = parseInt(noviceGuideStep)
        } else {
          this.noviceGuideStep = 0
        }
      },
      closeNoviceGuide() { //退出新手引导
        this.openNoviceGuide = false;
        sessionStorage.setItem("openNoviceGuide", false)
      },
      // 显示智能客服弹窗
      showServiceDrawerDrawer() {
        this.noviceGuideDrawer = false
        this.serviceDrawer = !this.serviceDrawer
        this.maskVisible = this.serviceDrawer ? true : false;
        this.detailVisible = false
      },
      startNoviceGuide() { //开启接入引导
        this.openNoviceGuide = true;
        sessionStorage.setItem("openNoviceGuide", true)
        this.noviceGuideStep = 0
        this.changeNoviceGuideStep('noviceGuideStep', this.noviceGuideStep)
      },
      //引导
      toGuide() {
        var commuType = sessionStorage.getItem("commuType");
        if (commuType == null || commuType == '' || commuType == '0') {
          this.$message({
            message: "请从顶端菜单中切换到指定通讯方式。",
            type: "error"
          });
          return false;
        }
        var name = "";
        if (this.noviceGuideStep == 0) {
          name = "创建网关协议"
        } else if (this.noviceGuideStep == 1) {
          name = "创建网关"
        } else if (this.noviceGuideStep == 2) {
          name = "创建设备协议"
        } else if (this.noviceGuideStep == 3) {
          name = "创建设备"
        } else if (this.noviceGuideStep == 4) {
          this.noviceGuideStep++
          //页面跳转
          this.$router.push({
            path: "/equipment/equipmentManagement",
          });
          return false;
        }
        this.changeNoviceGuideStep('noviceGuideStep', this.noviceGuideStep);
        //页面跳转
        this.$router.push({
          name: name,
          params: {
            guide: true
          }
        });
        this.cancelVisible();
      },
      nextStep() { //跳过步骤
        var commuType = sessionStorage.getItem("commuType");
        if (commuType == null || commuType == '' || commuType == '0') {
          this.$message({
            message: "请从顶端菜单中切换到指定通讯方式。",
            type: "error"
          });
          return false;
        }
        this.noviceGuideStep++;
        this.changeNoviceGuideStep("noviceGuideStep", this.noviceGuideStep)
      },
    },
    mounted() {
      let cur_path = this.$route.path; //获取当前路由
      if (cur_path != '/dashboard') {
        this.defaultActiveIndex = window.sessionStorage.getItem("commuType") ? window.sessionStorage.getItem(
          "commuType") : '1';
      } else {
        this.defaultActiveIndex = '0';
      }
      this.nickname = this.$cookies.get("nick_name") || ""
    },
    watch: {
      $route: function (to, from) {
        // 路由改变时执行
        // console.info(to.path);
        // if(!showTopMenu&&to.path)
        this.fetchNavData();
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/components/nav/topNav.vue